import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ROUTES } from '../lib/routes';
import Layout from '../components/layout/Layout';

// Public Pages
import HomePage from '../pages/HomePage';
import ResourceLibrary from '../pages/resources/ResourceLibrary';
import ResourceDetailPage from '../pages/resources/ResourceDetailPage';
import FamilyCaregiverHub from '../pages/resources/FamilyCaregiverHub';
import DirectoryPage from '../pages/public/DirectoryPage';
import SearchPage from '../pages/public/SearchPage';
import AboutPage from '../pages/public/AboutPage';
import CommunityPage from '../pages/public/CommunityPage';

// Volunteer Pages
import SubmissionCenter from '../pages/resources/SubmissionCenter';
import VolunteerDashboard from '../pages/volunteer/VolunteerDashboard';

// Admin Pages
import AdminDashboard from '../pages/admin/AdminDashboard';
import ModerationQueue from '../pages/admin/ModerationQueue';
import ResourceManagement from '../pages/admin/ResourceManagement';
import ResourceEditor from '../pages/admin/ResourceEditor';
import AdManagement from '../pages/admin/AdManagement';
import UsersAdmin from '../pages/admin/UsersAdmin';
import TranslationsAdmin from '../pages/admin/TranslationsAdmin';
import DirectoryAdmin from '../pages/admin/DirectoryAdmin';

// Guards
import { AuthGuard } from './routeGuards';

export default function AppRoutes() {
  return (
    <HashRouter>
      <Routes>
        <Route path={ROUTES.PUBLIC.HOME} element={<Layout />}>
          {/* Public Routes */}
          <Route index element={<HomePage />} />
          <Route path={ROUTES.PUBLIC.RESOURCES} element={<ResourceLibrary />} />
          <Route path="/resources/:slug" element={<ResourceDetailPage />} />
          <Route path={ROUTES.PUBLIC.CAREGIVER_HUB} element={<FamilyCaregiverHub />} />
          <Route path={ROUTES.PUBLIC.DIRECTORY} element={<DirectoryPage />} />
          <Route path={ROUTES.PUBLIC.SEARCH} element={<SearchPage />} />
          <Route path={ROUTES.PUBLIC.ABOUT} element={<AboutPage />} />
          <Route path={ROUTES.PUBLIC.COMMUNITY} element={<CommunityPage />} />

          {/* Volunteer Routes */}
          <Route element={<AuthGuard allowedRoles={['volunteer', 'moderator', 'super_admin']} />}>
            <Route path={ROUTES.PUBLIC.SUBMIT} element={<SubmissionCenter />} />
            <Route path={ROUTES.VOLUNTEER.DASHBOARD} element={<VolunteerDashboard />} />
          </Route>

          {/* Admin / Moderator Routes */}
          <Route element={<AuthGuard allowedRoles={['moderator', 'super_admin']} />}>
            <Route path={ROUTES.ADMIN.DASHBOARD} element={<AdminDashboard />} />
            <Route path={ROUTES.ADMIN.MODERATION} element={<ModerationQueue />} />
            <Route path={ROUTES.ADMIN.CONTENT} element={<ResourceManagement />} />
            <Route path={`${ROUTES.ADMIN.CONTENT}/new`} element={<ResourceEditor />} />
            <Route path={`${ROUTES.ADMIN.CONTENT}/edit/:id`} element={<ResourceEditor />} />
            <Route path={ROUTES.ADMIN.ADS} element={<AdManagement />} />
            <Route path={ROUTES.ADMIN.USERS} element={<UsersAdmin />} />
            <Route path={ROUTES.ADMIN.TRANSLATIONS} element={<TranslationsAdmin />} />
            <Route path={ROUTES.ADMIN.DIRECTORY} element={<DirectoryAdmin />} />
          </Route>

          {/* Catch-all */}
          <Route path="*" element={<Navigate to={ROUTES.PUBLIC.HOME} replace />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}